import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_PARCELS_FAILED,
  GET_PARCELS_SUCCESS,
  GET_PARCELS,
  UPDATE_PARCELS_FAILED,
  UPDATE_PARCELS_SUCCESS,
  UPDATE_PARCELS,
  CREATE_PARCELS_FAILED,
  CREATE_PARCELS_SUCCESS,
  CREATE_PARCELS,
  CREATE_GROUPING_PARCELS_FAILED,
  CREATE_GROUPING_PARCELS_SUCCESS,
  CREATE_GROUPING_PARCELS,
  UPDATE_PARCELS_STATUS,
  UPDATE_PARCELS_STATUS_SUCCESS,
  UPDATE_PARCELS_STATUS_FAILED,
  GET_PARCELS_WITH_ID,
  GET_PARCELS_WITH_ID_SUCCESS,
  GET_PARCELS_WITH_ID_FAILED,
  DELETE_PARCEL,
  DELETE_PARCEL_SUCCESS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_LOGS,
  CANCEL_PARCEL_SUCCESS,
  CANCEL_PARCEL_FAILED,
  CANCEL_PARCEL,
  UPDATE_PARCEL_OPERATOR,
  UPDATE_PARCEL_OPERATOR_SUCCESS,
  UPDATE_PARCEL_OPERATOR_FAILED,
  GET_PARCEL_INVENTORY_ITEMS,
  GET_PARCEL_INVENTORY_ITEMS_SUCCESS,
  GET_PARCEL_INVENTORY_ITEMS_FAILED,
  UPDATE_INVENTORY_ITEMS,
  UPDATE_INVENTORY_ITEMS_SUCCESS,
  UPDATE_INVENTORY_ITEMS_FAILED,
  GET_INVENTORY_ITEMS_WITH_SERIAL,
  GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS,
  GET_INVENTORY_ITEMS_WITH_STATUS,
  GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS,
  GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED,
  GET_INVENTORY_ITEMS_WITH_STATUS_FAILED,
  UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS,
  UPDATE_MULTI_INVENTORY_ITEMS_STATUS,
  DELETE_PARCEL_ITEMS,
  DELETE_PARCEL_ITEMS_SUCCESS,
  DELETE_PARCEL_ITEMS_FAILED,
  CREATE_PARCEL_ITEMS,
  CREATE_PARCEL_ITEMS_SUCCESS,
  CREATE_PARCEL_ITEMS_FAILED,
  GET_ALL_PARCELS_REPORT_SUCCESS,
  GET_ALL_PARCELS_REPORT_FAILED,
  GET_ALL_PARCELS_REPORT,
} from './constants';
import ParcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getParcels(actions: any): unknown {
  try {
    const {response, count} = yield ParcelsRepository.getParcels(actions);
    const locatedCardCount = yield ParcelsRepository.getParcelsCount({
      ...actions.payload,
      sort: 'id,desc',
      'status.in': ['LOCATED'],
    });
    const submittedCardCount = yield ParcelsRepository.getParcelsCount({
      ...actions.payload,
      sort: 'id,desc',
      'status.in': ['SUBMITTED'],
    });
    const progressCardCount = yield ParcelsRepository.getParcelsCount({
      ...actions.payload,
      sort: 'id,desc',
      'status.in': ['UNLOADING', 'ASSIGNED', 'UNLOADED', 'REGISTERED'],
    });
    const conflictCardCount = yield ParcelsRepository.getParcelsCount({
      ...actions.payload,
      sort: 'id,desc',
      'status.in': ['CONFLICTED'],
    });
    yield put({
      type: GET_PARCELS_SUCCESS,
      data: response.data,
      count: count.data,
      locatedCardCount: locatedCardCount.data,
      submittedCardCount: submittedCardCount.data,
      conflictCardCount: conflictCardCount.data,
      progressCardCount: progressCardCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARCELS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* getAllParcelsReport(actions: any): unknown {
  try {
    const response = yield ParcelsRepository.getAllParcelsReport(actions);
    yield put({
      type: GET_ALL_PARCELS_REPORT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_PARCELS_REPORT_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* getParcelInventoryItems(actions: any): any {
  const {callback} = actions.payload;
  try {
    const response = yield ParcelsRepository.getParcelInventoryItems(actions);
    if (callback) {
      callback();
    }
    yield put({
      type: GET_PARCEL_INVENTORY_ITEMS_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_PARCEL_INVENTORY_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* getInventoryItemsWithSerial(actions: any): any {
  const {callback} = actions.payload;
  try {
    const response = yield ParcelsRepository.getInventoryItemsWithSerial(
      actions
    );
    callback && callback();
    yield put({
      type: GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS,
      data: response.data.content,
    });
    if (response.data.content.length === 0)
      handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
  } catch (error) {
    yield put({
      type: GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* getInventoryItemsWithStatus(actions: any): any {
  try {
    const response = yield ParcelsRepository.getInventoryItemsWithStatus(
      actions
    );
    yield put({
      type: GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS,
      data: response.data.content,
    });
  } catch (error) {
    yield put({
      type: GET_INVENTORY_ITEMS_WITH_STATUS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateMultiInventoryItemsStatus(actions: any): any {
  try {
    const response = yield ParcelsRepository.updateMultiInventoryItemsStatus(
      actions
    );
    yield put({
      type: UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS,
      data: response.data.content,
    });
    yield put({
      type: GET_PARCELS,
      payload: {sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: GET_INVENTORY_ITEMS_WITH_STATUS_FAILED,
    });
    handleError(error);
  }
}

export function* updateParcels(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield ParcelsRepository.updateParcels(actions);
    yield put({
      type: UPDATE_PARCELS_SUCCESS,
    });
    yield put({
      type: GET_PARCELS,
      payload: {
        ...pagination,
      },
    });
    handleNotfication('محموله مورد نظر با موفقیت ویرایش شد ', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_PARCELS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateInventoryItems(actions: any): any {
  const {callback} = actions.payload;
  try {
    yield ParcelsRepository.updateInventoryItems(actions);
    yield put({
      type: UPDATE_INVENTORY_ITEMS_SUCCESS,
    });
    handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_INVENTORY_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateParcelOperator(actions: any): any {
  const {callback} = actions.payload;
  try {
    yield ParcelsRepository.updateParcelOperator(actions);
    yield put({
      type: UPDATE_PARCEL_OPERATOR_SUCCESS,
    });
    handleNotfication('محموله با موفقیت تخصیص داده شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_PARCEL_OPERATOR_FAILED,
      error: error.message,
    });
    handleNotfication('تخصیص محموله با خطا مواجه شد', 'error');
    handleError(error);
  }
}

export function* createParcel(actions: any): unknown {
  const {pagination, id, callback} = actions.payload;
  try {
    yield ParcelsRepository.createParcel(actions);
    yield put({
      type: CREATE_PARCELS_SUCCESS,
    });
    yield put({
      type: GET_PARCELS,
      payload: {...pagination, partnerId: {equals: id}},
    });
    handleNotfication('محموله با موفقیت اضافه شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: CREATE_PARCELS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
export function* createGroupingParcel(actions: any): unknown {
  const {pagination, id, callback} = actions.payload;
  try {
    yield ParcelsRepository.createGroupingParcel(actions);
    yield put({
      type: CREATE_GROUPING_PARCELS_SUCCESS,
    });
    yield put({
      type: GET_PARCELS,
      payload: {...pagination, partnerId: {equals: id}},
    });
    handleNotfication('محموله با موفقیت اضافه شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: CREATE_GROUPING_PARCELS_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن محصول با خطا مواجه شد', 'error');
    handleError(error);
  }
}

export function* createParcelItems(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    yield ParcelsRepository.createParcelItems(actions);
    yield put({
      type: CREATE_PARCEL_ITEMS_SUCCESS,
    });
    handleNotfication('آیتم محموله با موفقیت اضافه شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: CREATE_PARCEL_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error);
    callback && callback();
  }
}

export function* updateParcelStatus(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    yield ParcelsRepository.updateParcelStatus(actions);
    yield put({
      type: UPDATE_PARCELS_STATUS_SUCCESS,
    });
    handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
    callback && callback();
    yield put({
      type: GET_PARCELS,
      payload: {sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_PARCELS_STATUS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* geParcelsWithId(actions: any): unknown {
  try {
    const response = yield ParcelsRepository.geParcelsWithId(actions);
    yield put({
      type: GET_PARCELS_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARCELS_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* cancelParcel(actions: any): unknown {
  try {
    yield ParcelsRepository.cancelParcel(actions);
    yield put({
      type: CANCEL_PARCEL_SUCCESS,
    });
    yield put({
      type: GET_PARCELS,
    });
  } catch (error) {
    yield put({
      type: CANCEL_PARCEL_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* deleteParcel(actions: any): unknown {
  try {
    yield ParcelsRepository.deleteParcel(actions);
    yield put({
      type: DELETE_PARCEL_SUCCESS,
    });
    yield put({
      type: GET_PARCELS,
    });
  } catch (error) {
    yield put({
      type: CANCEL_PARCEL_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* deleteParcelItem(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    yield ParcelsRepository.deleteParcelItem(actions);
    yield put({
      type: DELETE_PARCEL_ITEMS_SUCCESS,
    });
    handleNotfication('آیتم محموله با موفیت حذف شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: DELETE_PARCEL_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* getLogs(actions: any): unknown {
  try {
    const response = yield ParcelsRepository.getLogs(actions);
    yield put({
      type: GET_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export default function* parcelsSaga() {
  yield takeLatest(GET_PARCELS, getParcels);
  yield takeLatest(GET_PARCEL_INVENTORY_ITEMS, getParcelInventoryItems);
  yield takeLatest(
    GET_INVENTORY_ITEMS_WITH_SERIAL,
    getInventoryItemsWithSerial
  );
  yield takeLatest(
    GET_INVENTORY_ITEMS_WITH_STATUS,
    getInventoryItemsWithStatus
  );
  yield takeLatest(UPDATE_INVENTORY_ITEMS, updateInventoryItems);
  yield takeLatest(UPDATE_PARCELS, updateParcels);
  yield takeLatest(CREATE_PARCELS, createParcel);
  yield takeLatest(CREATE_GROUPING_PARCELS, createGroupingParcel);
  yield takeLatest(CREATE_PARCEL_ITEMS, createParcelItems);
  yield takeLatest(UPDATE_PARCELS_STATUS, updateParcelStatus);
  yield takeLatest(UPDATE_PARCEL_OPERATOR, updateParcelOperator);
  yield takeLatest(GET_PARCELS_WITH_ID, geParcelsWithId);
  yield takeLatest(DELETE_PARCEL, deleteParcel);
  yield takeLatest(DELETE_PARCEL_ITEMS, deleteParcelItem);
  yield takeLatest(CANCEL_PARCEL, cancelParcel);
  yield takeLatest(GET_LOGS, getLogs);
  yield takeLatest(GET_ALL_PARCELS_REPORT, getAllParcelsReport);
  yield takeLatest(
    UPDATE_MULTI_INVENTORY_ITEMS_STATUS,
    updateMultiInventoryItemsStatus
  );
}
